import * as React from "react"
import { Message, List } from "semantic-ui-react"
import { connect } from "react-redux"
import { getTranslationsByScope } from "../../../core/reducers"

const Legend = ({ translations }: any) => (
  <Message className={"legend-block"}>
    <List>
      <List.Item>
        <List.Icon name={"folder open"} className={"normal"} />
        <List.Content>
          <List.Header>
            <p style={{ fontSize: "1em" }} className={"normal"}>
              {translations.topRefLegend}
            </p>
          </List.Header>
        </List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name={"file"} className={"inactive"} />
        <List.Content>
          <List.Header>
            <p style={{ fontSize: "1em" }} className={"inactive"}>
              {translations.inactiveLegend}
            </p>
          </List.Header>
        </List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name={"file"} className={"notValidated"} />
        <List.Content>
          <List.Header>
            <p style={{ fontSize: "1em" }} className={"notValidated"}>
              {translations.notValidatedLegend}
            </p>
          </List.Header>
        </List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name={"file"} className={"validated"} />
        <List.Content>
          <List.Header>
            <p style={{ fontSize: "1em" }} className={"validated"}>
              {translations.validatedLegend}
            </p>
          </List.Header>
        </List.Content>
      </List.Item>
      <List.Item>
        <List.Icon name={"file"} className={"invalid"} />
        <List.Content>
          <List.Header>
            <p style={{ fontSize: "1em" }} className={"invalid"}>
              {translations.invalidLegend}
            </p>
          </List.Header>
        </List.Content>
      </List.Item>
    </List>
  </Message>
)

const mapStateToProps = (state: any) => ({
  translations: getTranslationsByScope(state, "sideBar")
})

export default connect(
  mapStateToProps,
  undefined
)(Legend)
